import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { TFdrThGeoModuleObject } from 'components/domain/fdr-geo/fdr-geo.types';
import { FdrStaticRequestButton } from 'components/domain/fdr-request-button';
import { FdrGeoContentQuery } from 'schemas/query/geo/fdr-geo-content.generated';
import FdrGeoInformationSectionLeadText from './fdr-geo-information-section-lead-text';
import { TextContainer } from './fdr-geo-information-section.styles';

const GeoInformationWrapper = styled.div(({ theme: { colors } }) =>
  sx2CssThemeFn({
    backgroundColor: colors.paperGrey,
    color: 'black',
    fontSize: 2,
    '.long-text ': {
      p: {
        fontSize: [2, 3],
      },
    },
  })
);

const FdrGeoInformationSection: React.FC<IGeoInformationProps> = ({
  geo,
  geoModules,
}) => {
  return (
    <GeoInformationWrapper>
      <GeoInformation geo={geo} geoModules={geoModules} />
    </GeoInformationWrapper>
  );
};

const GeoInformationTitle = styled.h2(
  sx2CssThemeFn({
    pb: [3, 0],
  })
);

interface IGeoInformationProps {
  geo: FdrGeoContentQuery['fdrGeo'];
  geoModules: TFdrThGeoModuleObject;
}

function GeoInformation({
  geo,
  geoModules,
}: IGeoInformationProps): ReactElement {
  const { mobile } = useDeviceType();

  const { leadText, leadTitle, longTextBlocks } = geo;

  return (
    <TextContainer twoColumnView={!!leadTitle}>
      {leadTitle ? (
        <div>
          <GeoInformationTitle className="lead-title">
            {leadTitle}
          </GeoInformationTitle>
          {geoModules.requestButton && !mobile && leadTitle ? (
            <FdrStaticRequestButton
              link={geoModules.requestButton.link}
              caption={geoModules.requestButton.objectCaption}
            />
          ) : null}
        </div>
      ) : null}

      <div className="lead-text-wrapper">
        {leadText && (
          <FdrGeoInformationSectionLeadText
            text={leadText}
            withShowMore={!!longTextBlocks}
          />
        )}
        {geoModules.requestButton && (!leadTitle || mobile) ? (
          <FdrStaticRequestButton
            link={geoModules.requestButton.link}
            caption={geoModules.requestButton.objectCaption}
          />
        ) : null}
      </div>
    </TextContainer>
  );
}

export default FdrGeoInformationSection;
